module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Dislike-c83538d16b54a36d970c8e138213c7a5.svg";